import {
  SET_FOCUSED_ISLAND,
} from '../Actions';

const INITIAL_STATE = {
  focusedIsland: null,
};

export default function (state = INITIAL_STATE, action) {
  console.log('ACTION', action)
  switch(action.type) {
    case SET_FOCUSED_ISLAND:
      return { ...state, focusedIsland: action.focusedIsland }
  }
  return state;
}